/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { FcsFlag } from "../unleash";

export const FlagsPermissionCodBalance = {
  permission_cod_balance_enable: new Rox.Flag(false),
  permission_cod_balance_withdraw_view_detail: new Rox.Flag(false),
  permission_cod_balance_withdraw_request_detail: new Rox.Flag(false),
};

export const FlagsPermissionCodBalanceSwitchToFcs = {
  permission_cod_balance_switch: new FcsFlag.Flag(false),
  permission_cod_balance_export_switch: new FcsFlag.Flag(false),
  permission_cod_balance_withdraw_view_detail_switch: new FcsFlag.Flag(false),
  permission_cod_balance_withdraw_request_detail_switch: new FcsFlag.Flag(false)
};

export function initFlagsPermissionCodBalance() {
  // register flags with namespaces for better grouping
  Rox.register("featureCodBalance", FlagsPermissionCodBalance);
  FcsFlag.register("featureCodBalance", FlagsPermissionCodBalanceSwitchToFcs);
}
